export default {
  'pdp:reviews:details-text':
    'Durch den Abgleich mit unserer Kund*innendatenbank prüfen wir, ob das Produkt tatsächlich gekauft wurde. In diesem Fall wird die Bewertung mit „Verifiziert“ markiert.',
  'pdp:buy-panel:free-shipping-existing-customer':
    '<div><strong>Versandkostenfrei</strong><p> ab CHF 100 Bestellwert</p></div>',
  'pdp:buy-panel:free-shipping-existing-customer:without-style':
    'Versandkostenfrei ab CHF 100 Bestellwert',
  'pdp:buy-panel:coupon-price-personalization:mov-info':
    'Gutschein gilt für Bestellung ab CHF {mov} Bestellwert',
};
